module.exports = __webpack_public_path__ + "static/media/bg-banner-colleges.ff0634e7.jpg";